export default __webpack_public_path__ + "static/media/pantry1-afterH-2048w.58e11134.png";